import { saveAs } from "file-saver";
import { useRootStore } from "store";

/**
 * Download a file from a URL and save it to disk
 *
 * @param url URL to download from
 * @param fileName Name of the saved file
 * @param headers Any additional headers to send with the request
 */
export async function downloadAndSaveFile(
  url: string,
  fileName: string,
  headers: Headers = new Headers()
): Promise<void> {
  try {
    let response = await fetch(url, {
      headers,
      method: "GET"
    });

    if (!response.ok) {
      throw new Error("Could not fetch file");
    }

    // The response content is either a blob, or a pre-signed URL
    if (parseInt(response.headers.get("content-length") ?? "0") < 2000) {
      const responseClone = response.clone();
      const presignedUrl = (await responseClone.json()) as string;
      if (presignedUrl.match(/s3\.(eu-west-1|eu-north-1)\.amazonaws\.com/i)) {
        //TODO: Can see if it exactly matches the file's key
        // It looks like a presigned URL
        headers.delete("authorization"); // S3 does not like including auth headers in presigned URL:s
        response = await fetch(presignedUrl, {
          headers,
          method: "GET"
        });
      }
    }

    if (!response.ok) {
      throw new Error("Could not fetch file");
    }

    const blob = await response.blob();
    saveAs(blob, fileName);
  } catch (err) {
    useRootStore
      .getState()
      .error.appendErrorNotification("Misslyckades med nedladdningen", err);
  }
}
